export const MYRIAD_API_BASE = 'https://api-v2.myriadprotocol.com'
export const MYRIAD_NETWORK_ID_BNB = 56
export const MYRIAD_PREDICTION_MARKET_BNB = '0x39E66eE6b2ddaf4DEfDEd3038E0162180dbeF340'
export const MYRIAD_USD1_ADDRESS = '0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d'
export const MYRIAD_USD1_DECIMALS = 18

// PancakeSwap V3 on BSC — used for USDT ↔ USD1 swaps
export const PANCAKE_V3_ROUTER_BSC = '0x1b81D678ffb9C0263b24A97847620C99d213eB14'
export const PANCAKE_V3_FEE_TIER = 100 // 0.01% — stablecoin tier

// Order-Book (CLOB) contracts on BSC mainnet.
// Source: docs.myriad.markets/builders/contract-addresses.
// MYRIAD_CTF_EXCHANGE_BSC verified by EIP-712 signature recovery against
// a live filled order — domain name "MyriadCTFExchange", version "1".
export const MYRIAD_CTF_EXCHANGE_BSC =
	(process.env.NEXT_PUBLIC_MYRIAD_CTF_EXCHANGE_BSC as `0x${string}` | undefined) ??
	'0xa0b6f8ef8EdB64f395018D1933f2273Ce9f0f16A'
export const MYRIAD_OB_NEG_RISK_ADAPTER_BSC = '0xd96F26703Ddbf7d1Cb6858640eca34cF1893d53A' as const
export const MYRIAD_OB_CONDITIONAL_TOKENS_BSC =
	'0x6413734f92248D4B29ae35883290BD93212654Dc' as const
export const MYRIAD_OB_MANAGER_BSC = '0xaB5591E280fF9Bf368DB60c3b775b5C7Ba5ea3dB' as const
export const MYRIAD_OB_FEE_MODULE_BSC = '0xc1BB36bb0BA236603b95544E809F2ab1893BBC0C' as const
export const MYRIAD_OB_WRAPPED_COLLATERAL_BSC =
	'0x9F124ce59D8De0274574949400640a2677067ACC' as const

export const MYRIAD_EIP712_DOMAIN_VERSION = '1'

export type MyriadTimeInForce = 'GTC' | 'GTD' | 'FOK' | 'FAK'

export const MYRIAD_TIF_OPTIONS: MyriadTimeInForce[] = ['GTC', 'GTD', 'FOK', 'FAK']

// CLOB collateral on BSC is USD1 (18 decimals), confirmed by inspecting
// `token` field on live `tradingModel=ob` market responses. Earlier draft
// used BSC USDC.e — wrong; trades would have failed at the contract level.
export const MYRIAD_COLLATERAL_BSC = MYRIAD_USD1_ADDRESS
export const MYRIAD_COLLATERAL_DECIMALS = MYRIAD_USD1_DECIMALS

// Minimum order cost (USD1) for Myriad CLOB. Verified 2026-05-11 against
// `/orders?status=filled` — smallest filled order across 30-sample was
// $1.05 cost (amount × price). Anything under $1 silently fails to
// match: matcher accepts the order, parks it as `open` for ~14s, then
// the FAK/FOK TIF cycle kills it with `filledAmount: 0`. UX-wise that
// looks indistinguishable from a hung limit order, so we hard-gate
// submission below this floor.
export const MYRIAD_CLOB_MIN_ORDER_COST_USD = 1
